<template>
    <div class="enjoyPopup_box">
        <div class="jh_box">
            <div class="item_box">
                <img ref="imgRef" src="../../../static/image/enjoyImg/tecg.png" alt="" width="100%">
                <div :style="{width: widthData+'px',height: heightData+'px',bottom:bottomData+'px',left:leftData+'px',}" class="receive_box" @click="handleReceive"></div>
                <div :style="{width: widthData2+'px',height: heightData2+'px',bottom:bottomData2+'px',left:leftData2+'px',}" class="cancel_box" @click="handleCancel"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'enjoyPopupSuccess',
    data() {
        return {
            widthData:0,
            bottomData:0,
            heightData:0,
            leftData:0,
            widthData2:0,
            bottomData2:0,
            heightData2:0,
            leftData2:0,
        }
    },
    mounted() {
        setTimeout(() => {
            this.widthData = this.$refs.imgRef.width*0.7
            this.leftData = this.$refs.imgRef.width*0.15
            this.bottomData = this.$refs.imgRef.height*0.25
            this.heightData = this.$refs.imgRef.height*0.15

            this.widthData2 = this.$refs.imgRef.width*0.2
            this.leftData2 = this.$refs.imgRef.width*0.4
            this.bottomData2 = this.$refs.imgRef.height*0.1
            this.heightData2 = this.$refs.imgRef.height*0.13
        }, 1000)
        
    },

    methods: {
        // 前往只能匹配
        handleReceive() {
            this.$emit('handleReceive')
        },
        // 关闭弹窗
        handleCancel() {
            this.$emit('handleCancel')
        }
    }
}
</script>

<style lang="less" scoped>
.enjoyPopup_box {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.9);
    z-index: 999;
    .jh_box {
        padding: 0 20px;
        display: flex;
        align-items: center;
        height: 100%;
        justify-content: center;
        .item_box {
            position: relative;
            width: 375px;
            // height: 352px;
            text-align: center;
            .receive_box {
                position: absolute;
                border-radius: 50px;
                // background-color: pink;
            }
            .cancel_box {
                position: absolute;
                border-radius: 50px;
                // background-color: pink;
            }
        }
        
    }
}
</style>


// WEBPACK FOOTER //
// src/modules/Allpopup/enjoyPopupSuccess.vue